import history from "@ane/core/lib/CreateHistory";
import { combineEpics } from "redux-observable";
import { provideDataSourceListEpics } from "./DataSourceListEpic.js";
import dataSourceDeleteEpic from "./DataSourceDeleteEpic.js";
import dataSourceCloneEpic from "./DataSourceCloneEpic.js";
const dataSourceListEpic = provideDataSourceListEpics(history);
const rootEpic = combineEpics(dataSourceListEpic, dataSourceCloneEpic, dataSourceDeleteEpic);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
